import { render, staticRenderFns } from "./Depth4Sub.vue?vue&type=template&id=752340a2&scoped=true&"
import script from "./Depth4Sub.vue?vue&type=script&lang=js&"
export * from "./Depth4Sub.vue?vue&type=script&lang=js&"
import style0 from "./Depth4Sub.vue?vue&type=style&index=0&id=752340a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752340a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('752340a2')) {
      api.createRecord('752340a2', component.options)
    } else {
      api.reload('752340a2', component.options)
    }
    module.hot.accept("./Depth4Sub.vue?vue&type=template&id=752340a2&scoped=true&", function () {
      api.rerender('752340a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vendors/Terms/Depth4Sub.vue"
export default component.exports